import { Configuration } from "@seriously-rad/seriouslyrad-framework-core/Configuration";
import { WindowShim } from "@seriously-rad/seriouslyrad-framework-core/RadWindow";
import { registerPageManagerConfiguration } from "@seriously-rad/seriouslyrad-framework-core/Registration";
import { EntityCommandEntityFileCreateDocument } from "./EntityCommands/EntityCommandEntityFileCreateDocument";
import pageManagerConfiguration from "./Ui/PageManagerConfiguration";

const
    radWindow = WindowShim();

export async function registerModuleDocumentsAsync(configuration: Configuration)
{
    radWindow.entityManager?.registerCommand(new EntityCommandEntityFileCreateDocument());

    registerPageManagerConfiguration(configuration, pageManagerConfiguration);
}